
// Getters (GET*)
export const GET_PROFILE_LIST = 'GET_PROFILE_LIST';
export const GET_REGISTER_PROFILE_FORM_VISIBILITY = 'GET_REGISTER_PROFILE_FORM_VISIBILITY';
export const GET_SELECTED_PROFILE = 'GET_SELECTED_PROFILE';
export const GET_FLAG_LIST = 'GET_FLAG_LIST';
export const GET_VEHICLE_TYPE_LIST = 'GET_VEHICLE_TYPE_LIST';
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_CURRENT_PROFILE_TAB = 'GET_CURRENT_PROFILE_TAB';


// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
export const FETCH_PROFILE_LIST = 'FETCH_PROFILE_LIST';
export const CREATE_PROFILE_LIST = 'CREATE_PROFILE_LIST';
export const UPDATE_REGISTER_PROFILE_FORM_VISIBILITY = 'UPDATE_REGISTER_PROFILE_FORM_VISIBILITY';
export const UPDATE_SELECTED_PROFILE = 'UPDATE_SELECTED_PROFILE';
export const CREATE_NEW_PROFILE = 'CREATE_NEW_PROFILE';
export const UPDATE_PROFILE_LIST = 'UPDATE_PROFILE_LIST';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const FETCH_FLAG_LIST = 'FETCH_FLAG_LIST';
export const FETCH_VEHICLE_TYPE_LIST = 'FETCH_VEHICLE_TYPE_LIST';
export const FETCH_COUNTRY_LIST = 'FETCH_COUNTRY_LIST';
export const FETCH_PROFILE_FUNCTIONALITIES = 'FETCH_PROFILE_FUNCTIONALITIES';
export const UPDATE_SELECTED_PROFILE_FUNCTIONALITIES = 'UPDATE_PROFILE_FUNCTIONALITIES';
export const UPDATE_CURRENT_PROFILE_TAB = 'UPDATE_CURRENT_PROFILE_TAB';
export const FETCH_PROFILE_FUNCTIONALITIES_REPORT = 'FETCH_PROFILE_FUNCTIONALITIES_REPORT';



// Mutations (SET*, ADD*, REMOVE*)
export const SET_PROFILE_LIST = 'SET_PROFILE_LIST';
export const SET_REGISTER_PROFILE_FORM_VISIBILITY = 'SET_REGISTER_FORM_VISIBILITY';
export const SET_SELECTED_PROFILE = 'SET_SELECTED_PROFILE';
export const ADD_PROFILE_TO_LIST = 'ADD_PROFILE_TO_LIST';
export const SET_FLAG_LIST = 'SET_FLAG_LIST';
export const SET_VEHICLE_TYPE_LIST = 'SET_VEHICLE_TYPE_LIST';
export const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';
export const SET_PROFILE_FUNCTIONALITIES = 'SET_PROFILE_FUNCTIONALITIES';
export const SET_CURRENT_PROFILE_TAB = 'SET_CURRENT_PROFILE_TAB';


